import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { QuickView } from "../../api/GetJewellery"; 
import { Button } from 'primereact/button';
import { useAuth } from "../../context/AuthContext";
import { Tooltip } from "primereact/tooltip";

const DEFAULT_IMAGE = "/assets/images/VaultAccess/no-image3.png";

const ProductCard = ({ Style_ID, StyleNo, Image1, NewArrivalStatus, Status, LineAmount, Line1, Line2, product, onEnquiry, onAddToCart, isInEnquiry, handleAddToCart, isInCart, addingToCart, onQuickViewOpen }) => {


    const { user } = useAuth();

    const [imgLoaded, setImgLoaded] = useState(false);
    const [imgSrc, setImgSrc] = useState(Image1 || DEFAULT_IMAGE);
    const [loadingQuickView, setLoadingQuickView] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState({});

    const toggleTooltip = (id) => {
        setTooltipOpen(prev => ({ ...prev, [id]: !prev[id] }));
    };

    useEffect(() => {
        if (Image1) {
            setImgSrc(Image1);
        } else {
            setImgSrc(DEFAULT_IMAGE);
        }
    }, [Image1]);

    const handleQuickView = async (e) => {
        e.preventDefault(); 
        setLoadingQuickView(true);
        try {
            const request = {
                Style_ID: Style_ID,
                Customer_ID: user.SelectedCustomer_ID,
                StockCategory: "STOCK",
            };

            const response = await QuickView(request);
            if (response && response.Row && response.Row.length > 0) {
                onQuickViewOpen(response.Row[0]);
            } else if (response?.Row) {
                onQuickViewOpen(response.Row[0]);
            }
        } catch (error) {
            console.error("Quick View Error:", error);
        } finally {
            setLoadingQuickView(false);
        }
    };

    return (
        <motion.div className="product-card" initial={{ opacity: 0 }} animate={{ opacity: 1 }} whileHover={{ scale: 1.04 }} transition={{ type: "spring", stiffness: 300 }}>
            <div className="product-image-wrapper">
                {NewArrivalStatus && <span className="badge badge-new">NEW</span>}
                {Status && <span className="badge badge-ready">{Status}</span>}
               
                <Link to={`/product-detail/${Style_ID}`}>
                    <img
                        src={imgSrc}
                        alt={StyleNo}
                        loading="lazy"
                        className={`product-image ${imgLoaded ? "visible" : "loading"}`}
                        onLoad={() => setImgLoaded(true)}
                        onError={() => {
                            setImgSrc(DEFAULT_IMAGE);
                            setImgLoaded(true);
                        }}
                    />
                    {!imgLoaded && (
                        <div className="image-placeholder-shimmer" />
                    )}
                </Link>
            </div>

            <div className="product-info">
                <div className="produc-amount-info">
                    <div className="price-text">{LineAmount}</div>
                    <Button
                        icon={loadingQuickView ? "pi pi-spin pi-spinner" : "pi pi-eye"}
                        className="quick-view-btn"
                        onClick={handleQuickView}
                    />
                </div>
                <div className="style-no">{Line1}</div>
                <div className="metal-detail">{Line2}</div>
            </div>

            <div className="product-actions">
                <button
                    id={`enquiry-btn-${Style_ID}`}
                    type="button"
                    className={`btn-enquire ${isInEnquiry ? "btn-outline-enquiry disabled-btn" : "" }`}
                    onClick={() => {
                        if (isInEnquiry) return;
                        onEnquiry();
                    }}
                >
                    {isInEnquiry ? "IN ENQUIRY" : "ENQUIRE NOW"}
                </button>

                {isInEnquiry && (
                    <Tooltip
                        target={`#enquiry-btn-${Style_ID}`}
                        position="top"
                        event="click"
                    >
                        This product is already added to enquiry
                    </Tooltip>
                )}

                <button
                    id={`cart-btn-${Style_ID}`}
                    type="button"
                    className={`btn-cart-outline ${isInCart ? "btn-outline-cart disabled-btn" : isInEnquiry ? "disabled-btn" : "" }`}
                    onClick={() => {
                        if (isInCart || isInEnquiry || addingToCart) return;
                        handleAddToCart();
                    }}
                >
                    {isInCart ? "IN CART" : "ADD TO CART"}
                </button>

                {(isInCart || isInEnquiry) && (
                    <Tooltip
                        target={`#cart-btn-${Style_ID}`}
                        position="top"
                        event="click"
                    >
                        {isInCart
                            ? "This product is already in your cart"
                            : "Products in enquiry can’t be added to cart"}
                    </Tooltip>
                )}
            </div>
        </motion.div>
    );
};

export default ProductCard;